export enum CLMApiLogrRequestType {
    GoverningAgreementList = 'GoverningAgreementList',
    GoverningAgreementStatus = 'GoverningAgreementStatus',
    UpdateEngagementWithGoverningAgreement = 'UpdateEngagementWithGoverningAgreement',
    SendGoverningAgreement = 'SendGoverningAgreement',
}
